import { initializeApp } from 'firebase/app';
// import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getFirestore } from '@firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';

const firebaseConfig = {
    apiKey: 'AIzaSyCvLGlaLOhTPnbyJYczU4k7xZpwu4r30MU',
    // authDomain: 'efit-ba871.firebaseapp.com', // FOR DEVELOPMENT
    authDomain: 'everydaywarship.elevation.fit', // FOR PRODUCTION
    projectId: 'efit-ba871',
    storageBucket: 'efit-ba871.appspot.com',
    messagingSenderId: '916960279282',
    appId: '1:916960279282:web:2fc9a1eb4e9f0c51492e6b',
    measurementId: 'G-RECYTDYQRB',
};

const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const db = getFirestore(app);

// if (window.location.hostname === 'localhost') {
//     connectFunctionsEmulator(functions, 'localhost', 5001);
// }

const provider = new GoogleAuthProvider();

export const signInWithGoogle = () => {
    signInWithPopup(auth, provider)
        .then((result) => {
            const displayName = result.user.displayName;

            localStorage.setItem('displayName', displayName);
        })
        .catch((error) => {
            console.log(error);
        });
};
